import { p } from '@/plugins/permission'
import Vue from 'vue'
import vueResource from 'vue-resource'
Vue.use(vueResource)

const user = []

export default {
  index: {
    permission: [p.schoolManage, p.busManage],
    addPath: {},
    filters: [{
      value: 'class_id',
      type: 'hidden'
    }],
    tableItems: [{
      label: 'normal.class',
      value: 'class_name'
    }, {
      label: 'normal.name',
      value: 'name'
    }],
    buttonItems: [{
      buttonName: 'button.delete',
      type: 'ajax',
      path: '/api/class_manage/delete?id=%class_id%',
      showIf: key => { return true }
    }]
  },
  add: {
    permission: [p.schoolManage, p.busManage],
    formItems: [{
      label: 'normal.name',
      value: 'user_id',
      option: user,
      filterable: true,
      url: '/api/user/getSomeOne',
      rule: [
        { required: false, message: { text: 'formRule.normal.required', msg: 'normal.name' }, trigger: 'blur' }
      ],
      remoteMethod: async q => {
        if (q) {
          user.splice(0, user.length)
          const res = await Vue.http.get('/api/user/getSomeOne?label=' + q)
          user.push({
            label: '删除',
            value: 0
          })
          for (let i = 0; i < res.data.data.length; i++) {
            user.push(res.data.data[i])
          }
        }
      }
    }, {
      label: 'normal.class',
      value: 'class_id',
      option: 'classes',
      rule: [
        { required: true, message: { text: 'formRule.normal.required', msg: 'studentRoad.road' }, trigger: 'blur' }
      ]
    }]
  }
}
